<template>
<v-card flat tile>
  <div class="d-flex">
    <v-list-item>
      <v-list-item-action>
        <v-btn class="elevation-4"  :style="{backgroundColor : colorString}" icon @click="dialog = !dialog" :disabled="disabled" large></v-btn>
      </v-list-item-action>
      <!-- <v-list-item-icon><v-icon :style="{color : colorString}" size="48">mdi-square-rounded</v-icon></v-list-item-icon> -->
      <v-list-item-content>
        <v-list-item-title>{{label}}</v-list-item-title>
        <v-list-item-subtitle>{{colorString}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <!-- <div class="d-flex">
      <v-text-field type="number" label="R" hide-details outlined />
      <v-text-field type="number" label="G" hide-details outlined />
      <v-text-field type="number" label="B" hide-details outlined />
      <v-text-field type="number" label="A" hide-details outlined />
    </div> -->
  </div>

    <dialog-card title="Choose a color" :width="300" :cancel="null" v-model="dialog" :ok="ok">
      <v-color-picker 
        :hide-inputs="hideInputs"
        :hide-mode-switch="hideModeSwitch"
        :hide-canvas="hideCanvas"        
        :show-swatches="showSwatches"
        :disabled="disabled"
        :value="value"
        @input="handleChange($event)" flat/>
    </dialog-card>

</v-card>

</template>

<script>
import dialogCard from "@/_components/shared/dialog-card"
export default {
  name: 'ColorPicker',
  props : {
    /** Sets default color from the color palette */
    value : null,

    /** Sets label for the color palette */
    label : {type:String, default:"color"},

    /** Show or hide the RGB input values in the color palette */
    "hide-inputs" : { type:Boolean, default: false },

    /** Show or hide the color types like HEX, RGB & HSL */
    "hide-mode-switch" : { type:Boolean, default: true },

    /** You can manually select the tiny colors */
    "hide-canvas" : { type:Boolean, default: false },

    /** Show or hide the color bricks from lighter to darker */
    "show-swatches" : { type:Boolean, default: false },

    /** Cannot change the color */
    "disabled" : { type:Boolean, default: false },
  },
  components: {dialogCard},
  computed : {
    colorString()
    { //console.log(this.value);
      return typeof(this.value) == typeof("") 
        ? this.value 
        : `rgba(${this.value.r},${this.value.g},${this.value.b},${Math.round(this.value.a * 100,2)/100})`;
    }
  },
  data()
  {
    return {
      dialog:false,
    }
  },
  methods : {
    ok()
    {
      this.dialog = false;
    },
    handleChange(arg)
    {
      //Sometimes the control removes the alpha value. This ensures that we always have one.
      var rgba = Object.assign({a : 0.001}, arg);
      /**
       * Handles change event while picking the color
       */
      this.$emit("input", rgba);
    }
  }
}
</script>

<style scoped lang="scss">
</style>
